// Achievements.js
import React from 'react';
import achievements from './Achieve'; // Import the data
// You will also need to import the CSS file:
// import './Achievements.css';

const Achievements = () => {
  return (
    <section id="achievements" className="achievements-section">
      <div className="achievements-content">
        <h2 className="section-title">Certifications</h2>
        <p className="section-subtitle">Formal recognition of skills and continuous learning.</p>

        <div className="achievements-grid">
          {achievements.map(achievement => (
            <div className="achievement-card" key={achievement.id}>
              
              <div className="certificate-badge">
                {/* Image of the certificate badge/logo */}
                <img 
                  src={achievement.imageUrl} 
                  alt={`${achievement.title} badge`} 
                  className="badge-image"
                />
              </div>

              <div className="achievement-info">
                <h3 className="achievement-title">{achievement.title}</h3>
                <p className="achievement-issuer">{achievement.issuer} | {achievement.date}</p>
                <p className="achievement-description">{achievement.description}</p>
                
                <a 
                  href={achievement.certificateUrl} 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="link-certificate"
                >
                  View Certificate
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Achievements;